import { AppProviders } from "@/app/AppProviders";
import { AppShell } from "@/app/AppShell";
import { AuthBootstrap } from "@/app/auth/AuthBootstrap";
import { BrandingProvider } from "@/app/BrandingProvider";
import { AppRouter } from "@/app/router/AppRouter";

export function App() {
  return (
    <AppProviders>
      <AuthBootstrap>
        <BrandingProvider>
          <AppShell>
            <AppRouter />
          </AppShell>
        </BrandingProvider>
      </AuthBootstrap>
    </AppProviders>
  );
}
